import createVueApp from '@phoenix/createVueApp';
import StrapSearchResult from '@maison/components/strap-search/StrapSearchResult.vue';

const app = createVueApp({}, true);
app.component('StrapSearchResult', StrapSearchResult);
app.mount('#phoenix-strap-search-result');
